(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-sign-in-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('account-sign-in-help')) {
    customElements.define(
      'account-sign-in-help',
      class AccountSignInHelp extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.loginPath = new URL(this.dataset.loginUrl, window.location.origin).pathname;
          this.nativeAccountUrl = new URL(this.dataset.nativeAccountUrl, window.location.origin);
          this.accountUrl = new URL(this.dataset.accountUrl, window.location.origin);
          this.open = this.open.bind(this);
          this.close = this.close.bind(this);

          const addStorefrontReturnUrl = (urlValue) => {
            const target = new URL(urlValue, window.location.origin);
            target.searchParams.set('storefront_return_to', window.location.href);
            return target.toString();
          };

          const continueLink = this.querySelector('[data-account-help-continue]');
          if (continueLink) {
            continueLink.href = addStorefrontReturnUrl(this.accountUrl);
          }

          document.querySelectorAll('a[href]').forEach((link) => {
            const linkUrl = new URL(link.href, window.location.origin);
            const isAccountLink =
              linkUrl.origin === this.nativeAccountUrl.origin &&
              linkUrl.pathname === this.nativeAccountUrl.pathname;

            if (isAccountLink && !this.contains(link)) {
              link.href = addStorefrontReturnUrl(this.accountUrl);
            }

            if (this.dialog && linkUrl.pathname === this.loginPath) {
              link.addEventListener('click', this.open);
            }
          });

          if (!this.dialog) return;

          this.querySelectorAll('[data-account-help-close]').forEach((button) => {
            button.addEventListener('click', this.close);
          });

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
        }

        open(event) {
          if (!this.dialog) return;
          event.preventDefault();
          this.dialog.showModal();
        }

        close() {
          if (this.dialog) this.dialog.close();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taste-state-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('taste-state-personalization')) {
    customElements.define(
      'taste-state-personalization',
      class TasteStatePersonalization extends HTMLElement {
        static selections = new Map();

        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.textInput = this.querySelector('[data-personalized-text]');
          this.bootSelect = this.querySelector('[data-boot-select]');
          this.hatSelect = this.querySelector('[data-hat-select]');
          this.bootPreview = this.querySelector('[data-boot-preview]');
          this.hatPreview = this.querySelector('[data-hat-preview]');
          this.assetTemplates = JSON.parse(
            this.querySelector('[data-accessory-assets]').textContent,
          );
          this.feeStatus = this.querySelector('[data-fee-status]');
          this.feeProperty = this.querySelector('[data-fee-property]');
          this.sotrFont = this.querySelector('[data-sotr-state-font]');
          this.sotrBackgrounds = Array.from(this.querySelectorAll('[data-sotr-state-background]'));
          this.sotrTextColor = this.querySelector('[data-sotr-state-text-color]');
          this.sotrLivePreview = this.querySelector('[data-sotr-state-live-preview]');
          this.sotrLiveName = this.querySelector('[data-sotr-state-live-name]');
          this.sotrLiveStyle = this.querySelector('[data-sotr-state-live-style]');
          this.formAttempts = 0;
          this.variantAttempts = 0;
          this.restoreSelection();

          this.textInput.addEventListener('input', () => this.update());
          this.bootSelect.addEventListener('change', () => this.update());
          this.hatSelect.addEventListener('change', () => this.update());
          this.sotrFont?.addEventListener('change', () => this.update());
          this.sotrBackgrounds.forEach((input) => input.addEventListener('change', () => this.update()));

          this.connectForm();
          this.connectStatePicker();
          this.connectVariantPicker();
          this.update();
        }

        disconnectedCallback() {
          this.variantObserver?.disconnect();
          this.stateSelect?.removeEventListener('change', this.stateChangeHandler);
        }

        get selectionKey() {
          return this.dataset.sectionId;
        }

        restoreSelection() {
          const selection = TasteStatePersonalization.selections.get(this.selectionKey);

          if (!selection) return;

          this.textInput.value = selection.text;
          this.bootSelect.value = selection.boot;
          this.hatSelect.value = selection.hat;
          if (this.sotrFont && selection.font) this.sotrFont.value = selection.font;
          if (selection.background) {
            const background = this.sotrBackgrounds.find((input) => input.value === selection.background);
            if (background) background.checked = true;
          }
        }

        rememberSelection() {
          TasteStatePersonalization.selections.set(this.selectionKey, {
            text: this.textInput.value,
            boot: this.bootSelect.value,
            hat: this.hatSelect.value,
            font: this.sotrFont?.value || '',
            background: this.sotrBackgrounds.find((input) => input.checked)?.value || '',
          });
        }

        connectForm() {
          const root = this.closest('.shopify-section') || document;
          const form =
            root.querySelector('product-form form[action*="/cart/add"]') ||
            root.querySelector('form[action*="/cart/add"]');

          if (!form && this.formAttempts < 20) {
            this.formAttempts += 1;
            window.setTimeout(() => this.connectForm(), 100);
            return;
          }

          if (!form) return;

          let formId = form.getAttribute('id');
          if (!formId) {
            formId = `StatePersonalizationForm-${Date.now()}`;
            form.setAttribute('id', formId);
          }

          this.querySelectorAll('[data-personalization-field]').forEach((field) => {
            field.setAttribute('form', formId);
          });

          this.paymentButtons = Array.from(root.querySelectorAll('.shopify-payment-button'));
          this.updateExpressCheckout();
        }

        connectStatePicker() {
          const root = this.closest('.shopify-section') || document;

          this.stateSelect = root.querySelector('select[name="properties[State]"]');
          if (!this.stateSelect) return;

          this.previousStateName = this.stateSelect.value;
          this.stateChangeHandler = () => {
            const stateChanged = this.previousStateName !== this.stateSelect.value;

            this.previousStateName = this.stateSelect.value;
            if (stateChanged) {
              this.bootSelect.value = '';
              this.hatSelect.value = '';
            }

            this.bootSelect.disabled = !this.stateSelect.value;
            this.hatSelect.disabled = !this.stateSelect.value;
            this.update();
          };
          this.stateSelect.addEventListener('change', this.stateChangeHandler);
          if (!this.stateSelect.value) {
            this.bootSelect.value = '';
            this.hatSelect.value = '';
          }
          this.bootSelect.disabled = !this.stateSelect.value;
          this.hatSelect.disabled = !this.stateSelect.value;
          this.updateAccessoryPreviews();
          this.updateSotrPreview();
        }

        updateSotrPreview() {
          if (!this.sotrLivePreview) return;

          const selectedBackground = this.sotrBackgrounds.find((input) => input.checked);
          const selectedFont = this.sotrFont.options[this.sotrFont.selectedIndex];
          const name = this.textInput.value.trim();
          if (!selectedBackground || !selectedFont) return;

          this.sotrLivePreview.style.setProperty('--sotr-state-preview-bg', selectedBackground.dataset.backgroundColor);
          this.sotrLivePreview.style.setProperty('--sotr-state-preview-text', selectedBackground.dataset.textColor);
          this.sotrLiveName.style.fontFamily = selectedFont.dataset.fontFamily;
          this.sotrLiveName.textContent = name || 'Your name';
          this.sotrLiveStyle.textContent = selectedBackground.value + ' + ' + selectedBackground.dataset.textColorName;
          this.sotrTextColor.value = selectedBackground.dataset.textColorName;
        }

        connectVariantPicker() {
          this.variantRoot = this.closest('.shopify-section') || document;
          this.variantPicker = this.variantRoot.querySelector('variant-selects, variant-radios');

          if (!this.variantPicker && this.variantAttempts < 20) {
            this.variantAttempts += 1;
            window.setTimeout(() => this.connectVariantPicker(), 100);
            return;
          }

          if (!this.variantPicker) return;

          this.hideNativePersonalization();
          this.variantObserver = new MutationObserver(() => {
            this.variantPicker = this.variantRoot.querySelector('variant-selects, variant-radios');
            this.hideNativePersonalization();
            this.syncNativeVariant(this.isPersonalized());
          });
          this.variantObserver.observe(this.variantRoot, { childList: true, subtree: true });
          this.syncNativeVariant(this.isPersonalized());
        }

        getPersonalizationInputs() {
          return Array.from(
            this.variantPicker?.querySelectorAll(
              `input[type="radio"][data-option-name="${this.dataset.optionLabel}"]`,
            ) || [],
          );
        }

        hideNativePersonalization() {
          const personalizationInput = this.getPersonalizationInputs()[0];
          const personalizationGroup = personalizationInput?.closest('fieldset');

          if (personalizationGroup) {
            personalizationGroup.hidden = true;
            personalizationGroup.setAttribute('aria-hidden', 'true');
          }
        }

        isPersonalized() {
          return (
            this.textInput.value.trim().length > 0 ||
            this.bootSelect.value !== '' ||
            this.hatSelect.value !== ''
          );
        }

        update() {
          const personalized = this.isPersonalized();

          this.rememberSelection();
          this.feeStatus.hidden = !personalized;
          this.feeProperty.disabled = !personalized;
          this.syncNativeVariant(personalized);
          this.updateExpressCheckout();
          this.updateAccessoryPreviews();
          this.updateSotrPreview();
        }

        updateAccessoryPreviews() {
          const root = this.closest('.shopify-section') || document;
          const stateSelect =
            this.stateSelect || root.querySelector('select[name="properties[State]"]');
          const stateName = stateSelect?.value || '';

          this.updateAccessoryPreview('boot', this.bootSelect, this.bootPreview, stateName);
          this.updateAccessoryPreview('hat', this.hatSelect, this.hatPreview, stateName);
        }

        updateAccessoryPreview(type, select, preview, stateName) {
          const image = preview.querySelector('[data-preview-image]');
          const placeholder = preview.querySelector('[data-preview-placeholder]');
          const selectedOption = select.selectedOptions[0];
          const assetSlug = selectedOption?.dataset.assetSlug || 'default';
          const sourceTemplate = this.assetTemplates[type]?.[assetSlug];

          if (!stateName || !sourceTemplate) {
            image.removeAttribute('src');
            image.alt = '';
            image.hidden = true;
            placeholder.hidden = false;
            return;
          }

          const stateSlug = stateName
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');
          image.src = sourceTemplate.replace('[state]', stateSlug);
          const altTemplate =
            type === 'boot' ? this.dataset.bootPreviewAlt : this.dataset.hatPreviewAlt;

          image.alt = altTemplate
            .replace('[state]', stateName)
            .replace('[choice]', selectedOption.textContent.trim());
          image.hidden = false;
          placeholder.hidden = true;
        }

        syncNativeVariant(personalized) {
          const desiredValue = personalized
            ? this.dataset.personalizedValue
            : this.dataset.standardValue;
          const desiredInput = this.getPersonalizationInputs().find(
            (input) => input.value === desiredValue,
          );

          if (!desiredInput || desiredInput.checked) {
            this.updateExpressCheckout();
            return;
          }

          this.paymentButtons?.forEach((button) => {
            button.hidden = true;
          });
          desiredInput.checked = true;
          desiredInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        updateExpressCheckout() {
          if (!this.paymentButtons || !this.variantPicker) return;

          const root = this.closest('.shopify-section') || document;
          const stateSelect = root.querySelector('select[name="properties[State]"]');
          const desiredValue = this.isPersonalized()
            ? this.dataset.personalizedValue
            : this.dataset.standardValue;
          const variantIsSynchronized = this.getPersonalizationInputs().some(
            (input) => input.value === desiredValue && input.checked,
          );

          this.paymentButtons.forEach((button) => {
            button.hidden = !stateSelect?.value || !variantIsSynchronized;
          });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taste-state-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('taste-state-picker')) {
    customElements.define(
      'taste-state-picker',
      class TasteStatePicker extends HTMLElement {
        static selections = new Map();

        connectedCallback() {
          if (this.dataset.initialized === 'true') {
            this.observeGallery();
            return;
          }

          this.dataset.initialized = 'true';
          this.select = this.querySelector('[data-state-select]');
          this.preview = this.querySelector('[data-state-preview]');
          this.previewImage = this.querySelector('[data-state-preview-image]');
          this.formAttempts = 0;
          this.placementAttempts = 0;
          this.select.addEventListener('change', (event) => {
            event.stopPropagation();
            this.rememberSelection();
            this.updatePreview();
            this.updateExpressCheckout();
          });
          this.restoreSelection();
          this.updatePreview();
          this.placeBeforeSize();
          this.connectForm();
          this.observeGallery();
        }

        observeGallery() {
          if (this.dataset.requireState !== 'true') return;
          const root = this.closest('.shopify-section');
          if (!root) return;
          this.galleryObserver?.disconnect();
          this.galleryObserver = new MutationObserver(() => this.updateGallery());
          this.galleryObserver.observe(root.parentElement || root, { childList: true, subtree: true });
          this.updateGallery();
        }

        disconnectedCallback() {
          this.galleryObserver?.disconnect();
        }

        updateGallery() {
          if (this.dataset.requireState !== 'true' || !this.select) return;
          const option = this.select.selectedOptions[0];
          if (!option?.dataset.previewSrc) return;
          const root = this.closest('.shopify-section');
          if (!root) return;
          const source = new URL(option.dataset.previewSrc, window.location.origin);
          source.searchParams.set('width', '1946');
          const alt = this.dataset.previewAlt.replace('[state]', option.value);
          const modalId = root.querySelector('modal-opener')?.getAttribute('data-modal')?.slice(1);
          const modal = modalId ? document.getElementById(modalId) : null;
          const images = [...root.querySelectorAll('[id^="MediaGallery-"] img'), ...modal?.querySelectorAll('img') || []];
          images.forEach((image) => {
            if (image.getAttribute('src') !== source.href) image.setAttribute('src', source.href);
            image.removeAttribute('srcset');
            image.alt = alt;
          });
        }

        rememberSelection() {
          TasteStatePicker.selections.set(this.select.id, this.select.value);
        }

        restoreSelection() {
          const selectedState = TasteStatePicker.selections.get(this.select.id);
          const hasSelectedState = Array.from(this.select.options).some((option) => option.value === selectedState);

          if (hasSelectedState) {
            this.select.value = selectedState;
          }
        }

        placeBeforeSize() {
          const root = this.closest('.shopify-section') || document;
          const variantPicker = root.querySelector('variant-selects, variant-radios');
          const sizeGroup = Array.from(variantPicker?.querySelectorAll('fieldset') || []).find((fieldset) => {
            const legend = fieldset.querySelector('legend');
            return legend?.textContent.trim().toLowerCase() === this.dataset.sizeLabel.toLowerCase();
          });

          if (!sizeGroup && this.placementAttempts < 20) {
            this.placementAttempts += 1;
            window.setTimeout(() => this.placeBeforeSize(), 100);
            return;
          }

          if (sizeGroup && variantPicker.previousElementSibling !== this) {
            variantPicker.insertAdjacentElement('beforebegin', this);
          }

          if (sizeGroup && !sizeGroup.querySelector('[data-state-size-step]')) {
            const legend = sizeGroup.querySelector('legend');
            const step = document.createElement('p');
            const stepLabel = document.createElement('strong');

            step.className = 'taste-state-step';
            step.dataset.stateSizeStep = '';
            stepLabel.textContent = 'Step 2:';
            step.append(stepLabel, ' Tailor the final look with our small or large options.');
            legend?.insertAdjacentElement('afterend', step);
          }
        }

        connectForm() {
          const root = this.closest('.shopify-section') || document;
          const form =
            root.querySelector('product-form form[action*="/cart/add"]') ||
            root.querySelector('form[action*="/cart/add"]');

          if (!form && this.formAttempts < 20) {
            this.formAttempts += 1;
            window.setTimeout(() => this.connectForm(), 100);
            return;
          }

          if (!form) return;

          let formId = form.getAttribute('id');
          if (!formId) {
            formId = `StatePickerForm-${Date.now()}`;
            form.setAttribute('id', formId);
          }

          this.select.setAttribute('form', formId);
          if (this.dataset.requireState === 'true' && !form.dataset.cssaStateValidation) {
            form.dataset.cssaStateValidation = 'true';
            form.addEventListener('submit', (event) => {
              const currentSelect = document.getElementById(this.select.id);
              if (currentSelect && !currentSelect.reportValidity()) {
                event.preventDefault();
                event.stopImmediatePropagation();
              }
            }, true);
          }
          this.paymentButtons = Array.from(root.querySelectorAll('.shopify-payment-button'));
          this.updateExpressCheckout();
        }

        updateExpressCheckout() {
          this.paymentButtons?.forEach((button) => {
            button.hidden = !this.select.value;
          });
        }

        updatePreview() {
          this.updateGallery();
          const selectedOption = this.select.selectedOptions[0];
          const previewSource = selectedOption?.dataset.previewSrc;

          if (!previewSource) {
            this.previewImage.removeAttribute('src');
            this.previewImage.alt = '';
            this.previewImage.hidden = true;
            this.preview.setAttribute('aria-hidden', 'true');
            return;
          }

          this.previewImage.src = previewSource;
          this.previewImage.alt = this.dataset.previewAlt.replace('[state]', selectedOption.value);
          this.previewImage.hidden = false;
          this.preview.removeAttribute('aria-hidden');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
